import service from '@/utils/server';

const modName = '/mdm/carrier/';
//查询方法
export const pageInfo = data => {
  return service({
    url: modName + 'pageInfo',
    method: 'post',
    data
  });
};

//新增方法
export const addData = data => {
  return service({
    url: modName + 'addData',
    method: 'post',
    data
  });
};

//删除方法
export const deleteData = data => {
  return service({
    url: modName + 'deleteData',
    method: 'post',
    data
  });
};

//初始化修改
export const initEdit = data => {
  return service({
    url: modName + 'initEdit/' + data,
    method: 'post',
    data
  });
};

//修改方法
export const editData = data => {
  return service({
    url: modName + 'editData',
    method: 'post',
    data
  });
};

//导出文件方法
export const exportData = data => {
  let config = {
    timeout: 500000, // 请求超时时间
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'exportData',
    method: 'post',
    data
  });
};

//模板下载
export const downLoadTemplate = data => {
  let config = {
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'downloadTemplate/' + data.templateName,
    method: 'post',
    data
  });
};

//导入
export const importData = data => {
  let config = {
    timeout: 500000, // 请求超时时间
    headers: {
      "Content-Type": "multipart/form-data"
    },
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'importData',
    method: 'post',
    data
  });
};



// WEBPACK FOOTER //
// ./src/page/mdm/carrier/api/index.js